import { render, staticRenderFns } from "./StockSlipDefective.vue?vue&type=template&id=461449ce&scoped=true"
import script from "./StockSlipDefective.vue?vue&type=script&lang=js"
export * from "./StockSlipDefective.vue?vue&type=script&lang=js"
import style1 from "./StockSlipDefective.vue?vue&type=style&index=1&id=461449ce&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461449ce",
  null
  
)

export default component.exports